import React from 'react';

import './CustomFormFooter.css';

class CustomFormFooter extends React.Component {
    render() {
        return <div className="custom-form-footer">{this.props.children}</div>;
    }
}

export default CustomFormFooter;
// CustomFormHeader.jsx



// WEBPACK FOOTER //
// ./src/modules/form/components/custom-form-footer/CustomFormFooter.jsx